export const MAX_SUB_USERS_DEFAULT_VALUE = 1000;
export const MAX_EXTRA_STORAGE_DEFAULT_VALUE_IN_TB = 1000;